import { render, staticRenderFns } from "./AdminOrders.vue?vue&type=template&id=16aa47dd&scoped=true"
import script from "./AdminOrders.vue?vue&type=script&lang=js"
export * from "./AdminOrders.vue?vue&type=script&lang=js"
import style0 from "./AdminOrders.vue?vue&type=style&index=0&id=16aa47dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aa47dd",
  null
  
)

export default component.exports